module.exports = __webpack_public_path__ + "media/images/rent_icon_inactive-62144368.svg";